import { Document } from "../../type/document";
import api from "../api";

export async function create(params: Partial<Document>) {
    const response = await api.post(`/api/v1/userdocuments`, JSON.stringify(params), {
        headers: {
            'Content-type': 'application/json; charset=UTF-8',
        }
    });
    return response.data;
}

export async function list(userId: string | number) {
    const { data } = await api.get(`/api/v1/userdocuments/user_id/${userId}`, {
        headers: {
            'Content-type': 'application/json; charset=UTF-8',
        }
    })
    
    return data.results as Document[];
}